import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const FormHeading = ({ title, fields }) => {

  const clientSettings = useSelector(state => state.common.clientSettings);

  return (
    <div>
    {!!title &&
      <h2 className={clientSettings.newUIFlag && "form-heading"}>
        {title}
      </h2>}
    {!!fields &&
      fields.length > 0 &&
      <div className="u-margin-bottom">
        {fields.map(({ id, label, value }) =>
          <div key={id}>
            <strong>
              <FormattedMessage id={label} defaultMessage={label} />
            </strong>
            {": "}
            <span id={id}>
              <FormattedMessage id={value} defaultMessage={value} />
            </span>
          </div>
        )}
      </div>}
  </div>
  )
}

FormHeading.propTypes = {
  title: PropTypes.any,
  fields: PropTypes.array,
};

export default FormHeading;



// WEBPACK FOOTER //
// ./components/common/FormHeading.js